import React, { useEffect, useRef, useState } from 'react';
import { Form, InputRef } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { validateEmail } from 'utils/validate';
import AuthLayout from 'components/common/AuthLayout/AuthLayout';
import { emailRules } from 'utils/formRules';
import { Background, ButtonCommon, InputCommon, NotificationModal } from 'components/common';
import FormCommon from 'components/common/Form/FormCommon';
import useAuthContext from 'stores/auth-context';
import { AxiosError } from 'axios';
const ForgotPasswordPage: React.FC = () => {
  const [emailValid, setEmailValid] = useState<boolean | null>(null);
  const [isNotification, setIsNotification] = useState<boolean>(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const emailInputRef = useRef<InputRef>(null);
  const { onForgot, loading } = useAuthContext();
  const handleEmailChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!value) {
      setEmailValid(true);
    } else {
      try {
        await validateEmail(value);
        setEmailValid(false);
      } catch {
        setEmailValid(true);
      }
    }
  };
  const handForgot = async () => {
    try {
      await form.validateFields();
      const email = form.getFieldValue('email').toLowerCase();
      const res = await onForgot({ email, frontendUrl: window.location.origin });
      if (res?.success) {
        setIsNotification(true);
      } else {
        form.setFields([{ name: 'email', errors: ['Không tìm thấy gmail của bạn'] }]);
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError?.status === 404) {
        setEmailValid(true);
        form.setFields([{ name: 'email', errors: ['Không tìm thấy gmail của bạn'] }]);
      } else if (axiosError?.status === 400) {
        form.setFields([
          { name: 'password', value: '', errors: ['Sai mật khẩu, thử lại lần nữa hoặc chọn quên mật khẩu'] },
        ]);
      }
    }
  };
  useEffect(() => {
    emailInputRef.current?.focus();
  }, [emailValid]);
  return (
    <>
      {isNotification ? (
        <>
          <Background>
            <NotificationModal
              title='Yêu cầu mật khẩu mới thành công'
              label={`Quản trị viên của bạn sẽ gửi liên kết đặt lại mật khẩu mới cho bạn thông qua Gmail.<br/> Vui lòng xác nhận mail và đặt lại mật khẩu.`}
              buttonLabel='Trở về trang đăng nhập'
              onClick={() => {
                navigate('/login');
              }}
            />
          </Background>
        </>
      ) : (
        <AuthLayout>
          <div className='text-center gap-[4px] flex flex-col'>
            <h3 className='text-[24px] font-[700] leading-[32px] text-[var(--textBlack1E)]'>Bạn quên mật khẩu?</h3>
            <p className='text-[var(--textGray)] font-[400] text-[14px] leading-[22px]'>
              Vui lòng nhập vào email cần lấy lại mật khẩu
            </p>
          </div>
          <FormCommon form={form} layout='vertical' className='form-liemlam form-login'>
            <Form.Item label='Email:' name='email' rules={emailRules} hasFeedback>
              <InputCommon
                type='text'
                placeholder='Nhập vào email của bạn...'
                onChange={handleEmailChange}
                ref={emailInputRef}
              />
            </Form.Item>
          </FormCommon>
          <ButtonCommon color='basic' fullWidth radius='rounded' size='md' onClick={handForgot} loading={loading}>
            Xác nhận
          </ButtonCommon>

          <div className='text-center'>
            <Link to='/login' className='text-[var(--sematicColor)] text-[16px] font-[500] leading-[24px]'>
              Trở lại trang Đăng Nhập
            </Link>
          </div>
        </AuthLayout>
      )}
    </>
  );
};

export default ForgotPasswordPage;
